import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';
import { getModuleByName, getThumbnailFromRecommend } from '@src/common/utils';

const Thanks = props => {
    const { content } = props;

    const thanks = getModuleByName(content, '特别鸣谢')?.data.articleList[0];

    return (
        <div className={Style.thanks}>
            <div className={Style.item} />
            <div className={Style.item}>
                <a
                    href={thanks.url === 'hide' ? '#!' : thanks.url}
                    target={thanks.url === 'hide' ? '' : 'target'}
                    rel="noreferrer">
                    <img src={getThumbnailFromRecommend(thanks)} alt="" />
                </a>
            </div>
            <div className={Style.item} />
        </div>
    );
};

Thanks.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Thanks);
